export const easyListSplitter = () => {
  var j = 1;
  $.fn.easyListSplitter = function(options) {
    var defaults = {
      colNumber: 2,
      direction: 'vertical'
    };
    this.each(function() {
      var obj = $(this),
        settings = $.extend(defaults, options),
        totalListElements = $(this).children('li').length,
        baseColItems = Math.ceil(totalListElements / settings.colNumber),
        listClass = $(this).attr('class'),
        i = "";
      for (i = 1; i <= settings.colNumber; i++) {
        if (i == 1) $(this).addClass('listCol1').wrap('<div class="listContainer' + j + '"></div>');
        else if ($(this).is('ul')) $(this).parents('.listContainer' + j).append('<ul class="listCol' + i + '"></ul>');
        else $(this).parents('.listContainer' + j).append('<ol class="listCol' + i + '"></ol>');
        $('.listContainer' + j + ' > ul,.listContainer' + j + ' > ol').addClass(listClass);
      }
      var listItem = 0,
        k = 1,
        l = 0;
      if (settings.direction == 'vertical') {
        $(this).children('li').each(function() {
          listItem++;
          if (listItem > baseColItems * (settings.colNumber - 1)) $(this).parents('.listContainer' + j).find('.listCol' + settings.colNumber).append(this);
          else {
            if (listItem <= (baseColItems * k)) $(this).parents('.listContainer' + j).find('.listCol' + k).append(this);
            else {
              $(this).parents('.listContainer' + j).find('.listCol' + (k + 1)).append(this);
              k++;
            }
          }
        });
        $('.listContainer' + j).find('ol,ul').each(function() {
          if ($(this).children().length == 0) $(this).remove();
        });
      } else {
        $(this).children('li').each(function() {
          l++;
          if (l <= settings.colNumber) $(this).parents('.listContainer' + j).find('.listCol' + l).append(this);
          else {
            l = 1;
            $(this).parents('.listContainer' + j).find('.listCol' + l).append(this);
          }
        });
      }
      $('.listContainer' + j).find('ol:last,ul:last').addClass('last'); // Set class last on the last UL or OL
      j++;
    });
  };
  
  $('.brand-listing ul').easyListSplitter({
    colNumber: 5
  });

};
